var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"timesline-container"},[_c('time-line',{attrs:{"data":_vm.data.wayBill,"start-place":_vm.data.startPlace,"end-place":_vm.data.stopPlace}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }